import type ProgramCurriculumsV1 from 'bundles/naptimejs/resources/programCurriculums.v1';

export const NUM_CAREER_CARDS_TO_SHOW = 8;

export const Partners = {
  GOOGLE: 'google',
  IBM: 'ibm',
  FACEBOOK: 'facebook',
  SALESFORCE: 'salesforce',
  INTUIT: 'intuit',
  HUBSPOT: 'hubspot-academy',
} as const;

export enum CoreRoleCollectionNames {
  DATA_WAREHOUSE_DEVELOPER = 'Career Academy: Data Warehouse Developer',
  DEVOPS_ENGINEER = 'Career Academy: DevOps Engineer',
  MARKETING_ANALYST = 'Career Academy: Marketing Analyst',
  DATA_ENGINEER = 'Career Academy: Data Engineer',
  SALES_OPERATIONS_SPECIALIST = 'Career Academy: Sales Operations Specialist',
  BOOKKEEPER = 'Career Academy: Bookkeeper',
  APPLICATION_DEVELOPER = 'Career Academy: Application Developer',
  SALES_DEVELOPMENT_REPRESENTATIVE = 'Career Academy: Sales Development Representative',
  CYBERSECURITY_PROFESSIONAL = 'Career Academy: Cybersecurity Professional',
  DATA_SCIENTIST = 'Career Academy: Data Scientist',
  SOCIAL_MEDIA_MARKETER = 'Career Academy: Social Media Marketer',
  UX_DESIGNER = 'Career Academy: UX Designer',
  PROJECT_MANAGER = 'Career Academy: Project Manager',
  DATA_ANALYST = 'Career Academy: Data Analyst',
  IT_SUPPORT_SPECIALIST = 'Career Academy: IT Support Specialist',
  DIGITAL_MARKETER = 'Career Academy: Digital Marketer',
  SALES_REPRESENTATIVE = 'Career Academy: Sales Representative',
  FRONT_END_DEVELOPER = 'Career Academy: Front-End Developer',
  BACK_END_DEVELOPER = 'Career Academy: Back-End Developer',
  IOS_DEVELOPER = 'Career Academy: iOS Developer',
  ANDROID_DEVELOPER = 'Career Academy: Android Developer',
  TECHNOLOGY_CONSULTANT = 'Career Academy: Technology Consultant',
  CAREER_COACH = 'Career Academy: Career Coach',
  IT_PROJECT_MANAGER = 'Career Academy: IT Project Manager',
  CUSTOMER_SERVICE_REPRESENTATIVE = 'Career Academy: Customer Service Representative',
  SOLUTIONS_ENGINEER = 'Career Academy: Solutions Architect',
  NETWORK_ENGINEER = 'Career Academy: Network Engineer',
  HUMAN_RESOURCES_SPECIALIST = 'Career Academy: Human Resources Specialist',
  BUSINESS_INTELLIGENCE_ANALYST = 'Career Academy: Business Intelligence Analyst',
  SUPPLY_CHAIN_ANALYST = 'Career Academy: Supply Chain Analyst',
  PRODUCT_MANAGER = 'Career Academy: Product Manager',
  REAL_ESTATE_AGENT = 'Career Academy: Real Estate Agent',
  FULL_STACK_DEVELOPER = 'Career Academy: Full Stack Developer',
  PAYROLL_SPECIALIST = 'Career Academy: Payroll Specialist',
  COMPENSATION_ANALYST = 'Career Academy: Compensation Analyst',
  CLOUD_SUPPORT_ASSOCIATE = 'Career Academy: Cloud Support Associate',
  PUBLIC_RELATIONS_SPECIALIST = 'Career Academy: Public Relations Specialist',
  MOBILE_APP_DEVELOPER = 'Career Academy: Mobile App Developer',
  BUSINESS_ANALYST = 'Career Academy: Business Analyst',
  GAME_DESIGNER = 'Career Academy: Game Designer',
  INSURANCE_SALES_AGENT = 'Career Academy: Insurance Sales Agent',
  PROGRAM_MANAGER = 'Career Academy: Program Manager',
  PERSONAL_TRAINER = 'Career Academy: Personal Trainer',
  GRAPHIC_DESIGNER = 'Career Academy: Graphic Designer',
  JUNIOR_SOFTWARE_DEVELOPER = 'Career Academy: Junior Software Developer',
  CONTENT_CREATOR = 'Career Academy: Content Creator',
  PYTHON_DEVELOPER = 'Career Academy: Python Developer',
  DATA_MANAGER = 'Career Academy: Data Manager',
}

export const RoleCollectionSlugs = {
  DATA_WAREHOUSE_DEVELOPER: 'data-warehousing-specialist',
  DEVOPS_ENGINEER: 'devops-software-engineer',
  MARKETING_ANALYST: 'marketing-analyst',
  DATA_ENGINEER: 'data-engineer',
  SALES_OPERATIONS_SPECIALIST: 'sales-ops-support-specialist',
  BOOKKEEPER: 'bookkeeper',
  APPLICATION_DEVELOPER: 'application-developer',
  SALES_DEVELOPMENT_REPRESENTATIVE: 'sales-development-representative',
  CYBERSECURITY_PROFESSIONAL: 'cybersecurity-analyst',
  DATA_SCIENTIST: 'data-scientist',
  SOCIAL_MEDIA_MARKETER: 'social-media-specialist',
  UX_DESIGNER: 'ux-designer',
  PROJECT_MANAGER: 'project-manager',
  DATA_ANALYST: 'data-analyst',
  IT_SUPPORT_SPECIALIST: 'it-support-specialist',
  DIGITAL_MARKETER: 'digital-marketer',
  SALES_REPRESENTATIVE: 'sales-representative',
  FRONT_END_DEVELOPER: 'front-end-developer',
  BACK_END_DEVELOPER: 'back-end-developer',
  IOS_DEVELOPER: 'ios-developer',
  ANDROID_DEVELOPER: 'android-developer',
  TECHNOLOGY_CONSULTANT: 'technology-consultant',
  CAREER_COACH: 'career-coach',
  IT_PROJECT_MANAGER: 'it-project-manager',
  CUSTOMER_SERVICE_REPRESENTATIVE: 'customer-service-representative',
  SOLUTIONS_ENGINEER: 'solutions-architect',
  NETWORK_ENGINEER: 'network-engineer',
  HUMAN_RESOURCES_SPECIALIST: 'human-resources-specialist',
  BUSINESS_INTELLIGENCE_ANALYST: 'business-intelligence-analyst',
  SUPPLY_CHAIN_ANALYST: 'supply-chain-analyst',
  PRODUCT_MANAGER: 'product-manager',
  REAL_ESTATE_AGENT: 'real-estate-agent',
  FULL_STACK_DEVELOPER: 'full-stack-developer',
  PAYROLL_SPECIALIST: 'payroll-specialist',
  COMPENSATION_ANALYST: 'compensation-analyst',
  CLOUD_SUPPORT_ASSOCIATE: 'cloud-support-associate',
  PUBLIC_RELATIONS_SPECIALIST: 'public-relations-specialist',
  MOBILE_APP_DEVELOPER: 'mobile-app-developer',
  BUSINESS_ANALYST: 'business-analyst',
  GAME_DESIGNER: 'game-designer',
  INSURANCE_SALES_AGENT: 'insurance-sales-agent',
  PROGRAM_MANAGER: 'program-manager',
  PERSONAL_TRAINER: 'personal-trainer',
  GRAPHIC_DESIGNER: 'graphic-designer',
  JUNIOR_SOFTWARE_DEVELOPER: 'junior-software-developer',
  CONTENT_CREATOR: 'content-creator',
  PYTHON_DEVELOPER: 'python-developer',
  DATA_MANAGER: 'data-manager',
} as const;

export const roleToCollectionsSlugMapping = {
  [RoleCollectionSlugs.DATA_WAREHOUSE_DEVELOPER]: CoreRoleCollectionNames.DATA_WAREHOUSE_DEVELOPER,
  [RoleCollectionSlugs.DEVOPS_ENGINEER]: CoreRoleCollectionNames.DEVOPS_ENGINEER,
  [RoleCollectionSlugs.MARKETING_ANALYST]: CoreRoleCollectionNames.MARKETING_ANALYST,
  [RoleCollectionSlugs.DATA_ENGINEER]: CoreRoleCollectionNames.DATA_ENGINEER,
  [RoleCollectionSlugs.SALES_OPERATIONS_SPECIALIST]: CoreRoleCollectionNames.SALES_OPERATIONS_SPECIALIST,
  [RoleCollectionSlugs.BOOKKEEPER]: CoreRoleCollectionNames.BOOKKEEPER,
  [RoleCollectionSlugs.APPLICATION_DEVELOPER]: CoreRoleCollectionNames.APPLICATION_DEVELOPER,
  [RoleCollectionSlugs.SALES_DEVELOPMENT_REPRESENTATIVE]: CoreRoleCollectionNames.SALES_DEVELOPMENT_REPRESENTATIVE,
  [RoleCollectionSlugs.CYBERSECURITY_PROFESSIONAL]: CoreRoleCollectionNames.CYBERSECURITY_PROFESSIONAL,
  [RoleCollectionSlugs.DATA_SCIENTIST]: CoreRoleCollectionNames.DATA_SCIENTIST,
  [RoleCollectionSlugs.SOCIAL_MEDIA_MARKETER]: CoreRoleCollectionNames.SOCIAL_MEDIA_MARKETER,
  [RoleCollectionSlugs.UX_DESIGNER]: CoreRoleCollectionNames.UX_DESIGNER,
  [RoleCollectionSlugs.PROJECT_MANAGER]: CoreRoleCollectionNames.PROJECT_MANAGER,
  [RoleCollectionSlugs.DATA_ANALYST]: CoreRoleCollectionNames.DATA_ANALYST,
  [RoleCollectionSlugs.IT_SUPPORT_SPECIALIST]: CoreRoleCollectionNames.IT_SUPPORT_SPECIALIST,
  [RoleCollectionSlugs.DIGITAL_MARKETER]: CoreRoleCollectionNames.DIGITAL_MARKETER,
  [RoleCollectionSlugs.SALES_REPRESENTATIVE]: CoreRoleCollectionNames.SALES_REPRESENTATIVE,
  [RoleCollectionSlugs.FRONT_END_DEVELOPER]: CoreRoleCollectionNames.FRONT_END_DEVELOPER,
  [RoleCollectionSlugs.BACK_END_DEVELOPER]: CoreRoleCollectionNames.BACK_END_DEVELOPER,
  [RoleCollectionSlugs.IOS_DEVELOPER]: CoreRoleCollectionNames.IOS_DEVELOPER,
  [RoleCollectionSlugs.ANDROID_DEVELOPER]: CoreRoleCollectionNames.ANDROID_DEVELOPER,
  [RoleCollectionSlugs.TECHNOLOGY_CONSULTANT]: CoreRoleCollectionNames.TECHNOLOGY_CONSULTANT,
  [RoleCollectionSlugs.CAREER_COACH]: CoreRoleCollectionNames.CAREER_COACH,
  [RoleCollectionSlugs.IT_PROJECT_MANAGER]: CoreRoleCollectionNames.IT_PROJECT_MANAGER,
  [RoleCollectionSlugs.CUSTOMER_SERVICE_REPRESENTATIVE]: CoreRoleCollectionNames.CUSTOMER_SERVICE_REPRESENTATIVE,
  [RoleCollectionSlugs.SOLUTIONS_ENGINEER]: CoreRoleCollectionNames.SOLUTIONS_ENGINEER,
  [RoleCollectionSlugs.NETWORK_ENGINEER]: CoreRoleCollectionNames.NETWORK_ENGINEER,
  [RoleCollectionSlugs.HUMAN_RESOURCES_SPECIALIST]: CoreRoleCollectionNames.HUMAN_RESOURCES_SPECIALIST,
  [RoleCollectionSlugs.BUSINESS_INTELLIGENCE_ANALYST]: CoreRoleCollectionNames.BUSINESS_INTELLIGENCE_ANALYST,
  [RoleCollectionSlugs.SUPPLY_CHAIN_ANALYST]: CoreRoleCollectionNames.SUPPLY_CHAIN_ANALYST,
  [RoleCollectionSlugs.PRODUCT_MANAGER]: CoreRoleCollectionNames.PRODUCT_MANAGER,
  [RoleCollectionSlugs.REAL_ESTATE_AGENT]: CoreRoleCollectionNames.REAL_ESTATE_AGENT,
  [RoleCollectionSlugs.FULL_STACK_DEVELOPER]: CoreRoleCollectionNames.FULL_STACK_DEVELOPER,
  [RoleCollectionSlugs.PAYROLL_SPECIALIST]: CoreRoleCollectionNames.PAYROLL_SPECIALIST,
  [RoleCollectionSlugs.COMPENSATION_ANALYST]: CoreRoleCollectionNames.COMPENSATION_ANALYST,
  [RoleCollectionSlugs.CLOUD_SUPPORT_ASSOCIATE]: CoreRoleCollectionNames.CLOUD_SUPPORT_ASSOCIATE,
  [RoleCollectionSlugs.PUBLIC_RELATIONS_SPECIALIST]: CoreRoleCollectionNames.PUBLIC_RELATIONS_SPECIALIST,
  [RoleCollectionSlugs.MOBILE_APP_DEVELOPER]: CoreRoleCollectionNames.MOBILE_APP_DEVELOPER,
  [RoleCollectionSlugs.BUSINESS_ANALYST]: CoreRoleCollectionNames.BUSINESS_ANALYST,
  [RoleCollectionSlugs.GAME_DESIGNER]: CoreRoleCollectionNames.GAME_DESIGNER,
  [RoleCollectionSlugs.INSURANCE_SALES_AGENT]: CoreRoleCollectionNames.INSURANCE_SALES_AGENT,
  [RoleCollectionSlugs.PROGRAM_MANAGER]: CoreRoleCollectionNames.PROGRAM_MANAGER,
  [RoleCollectionSlugs.PERSONAL_TRAINER]: CoreRoleCollectionNames.PERSONAL_TRAINER,
  [RoleCollectionSlugs.GRAPHIC_DESIGNER]: CoreRoleCollectionNames.GRAPHIC_DESIGNER,
  [RoleCollectionSlugs.JUNIOR_SOFTWARE_DEVELOPER]: CoreRoleCollectionNames.JUNIOR_SOFTWARE_DEVELOPER,
  [RoleCollectionSlugs.CONTENT_CREATOR]: CoreRoleCollectionNames.CONTENT_CREATOR,
  [RoleCollectionSlugs.PYTHON_DEVELOPER]: CoreRoleCollectionNames.PYTHON_DEVELOPER,
  [RoleCollectionSlugs.DATA_MANAGER]: CoreRoleCollectionNames.DATA_MANAGER,
};

export const getCareerAcademyCollectionIds = ({ curriculum }: { curriculum?: ProgramCurriculumsV1 }) =>
  [...(curriculum?.definition.electiveTracks ?? []), ...(curriculum?.definition.coreTracks ?? [])]
    .filter((track) => track.roleId)
    .map((collectionData) => collectionData.id);
